export default class EventCard extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-event-card', EventCard);
